import { SortableContainer, SortableContainerProps } from 'react-sortable-hoc';

import LocationItem, { DragHandle } from './LocationItem';

import {
  CartSiteAddress,
  useCartContext,
} from 'screens/AccessExpressV3/CartProvider';
import { SearchAccessAddressBar } from './SearchAccessAddressBar';
import { QuoteLocation } from 'api/accessexpress/schema';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

interface LocationsListProps extends SortableContainerProps {
  items: Array<CartSiteAddress>;
  onChange: (index: number, value?: CartSiteAddress) => void;
}

interface ListProps extends LocationsListProps {
  disabledNext: boolean;
  setDisabledNext: (disabledNext: boolean) => void;
}

const List = SortableContainer<ListProps>(
  ({ items, onChange, disabledNext, setDisabledNext }: ListProps) => {
    const handleAdd = (value?: QuoteLocation) => {
      onChange(
        items.length,
        value
          ? { ...value, id: value?.id ? `${value?.id}` : undefined }
          : undefined,
      );
      setDisabledNext(true);
    };

    return (
      <div className="flex select-none flex-col">
        {items.map((value, index) => (
          <LocationItem
            key={`item-${value.id}`}
            value={value}
            onChange={onChange}
            index={index}
            index_={index}
          />
        ))}

        {items.length < 10 ? (
          <div className={clsx('relative mb-8')}>
            {disabledNext && items.length > 0 && (
              <div
                className="absolute inset-0 cursor-pointer bg-blue-900 opacity-40"
                onClick={() => setDisabledNext(false)}
              />
            )}
            <div className="flex flex-none items-center gap-1">
              <DragHandle />
              <SearchAccessAddressBar
                onAddressSelected={handleAdd}
                focus={!disabledNext}
                isDisabled={disabledNext && items.length > 0}
                className="flex flex-1 [&>.search-bar-wrapper]:w-full [&_input]:text-sm"
                variant="border-blue"
                prefixElement={
                  <div className="-ml-3 flex w-5 flex-none justify-end text-sm text-content-base-subdued">
                    {items.length + 1}.
                  </div>
                }
              />
            </div>
          </div>
        ) : null}
        {items.length === 0 ? (
          <div className={clsx('relative mb-8')}>
            <div
              className="absolute inset-0 cursor-pointer bg-blue-900 opacity-40"
              onClick={() => setDisabledNext(false)}
            />
            <div className="flex flex-none items-center gap-1">
              <DragHandle />
              <SearchAccessAddressBar
                onAddressSelected={() => {}}
                initialFocus={false}
                className="flex flex-1 [&>.search-bar-wrapper]:w-full [&_input]:text-sm"
                variant="border-blue"
                prefixElement={
                  <div className="-ml-3 flex w-5 flex-none justify-end text-sm text-content-base-subdued">
                    2.
                  </div>
                }
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  },
);

const LocationsList = observer(function ObservedComponent(
  props: LocationsListProps & SortableContainerProps,
) {
  const cart = useCartContext();
  const [disabledNext, setDisabledNext] = useState(true);

  useEffect(() => {
    setDisabledNext(true);
  }, [cart.isOpen]);
  return (
    <List
      {...props}
      disabledNext={disabledNext}
      setDisabledNext={setDisabledNext}
    />
  );
});

export default LocationsList;
